import React from "react";
import { TabPanel, Tabs } from "../../components/common/Tab";
import ManageGamesCard from "./ManageGameCard";

export default function ManageGamesTabs({ 
  tabsData, 
  tabStyle, 
  allGameSettings, 
  refreshGames,
  activeTab,
  onTabChange,
  onToggle,
  onModify
}) {
  // Dynamic card data

  return (
    <div className="px-4 pt-3">
      <Tabs
        tabStyle="flex border-b space-x-2.5 text-xs border-[#E1E7EF]"
        activeClass="text-[#0E64D1] px-2 pb-4 border-b-2 border-[#0E64D1]"
        inactiveClass="text-[#12131A] px-2 pb-4"
        activeTab={activeTab}
        onTabChange={onTabChange}
      >
        {tabsData.map((tab, index) => (
          <TabPanel key={index} title={tab.title} value={tab.title}>
            <div
              className="space-y-3 h-[774px] overflow-y-auto hide-scrollbar"
              style={{ height: "calc(100vh - 150px)" }}
            >
              {tab.cards?.map((card, idx) => (
                <ManageGamesCard
                  key={idx}
                  {...card}
                  allGameSettings={allGameSettings}
                  refreshGames={refreshGames}
                  onToggle={onToggle}
                  onModify={onModify}
                />
              ))}
            </div>
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
}
